import * as React from "react"
import { useEffect } from "react"

import './index.less'
import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";

import Navbar from "../components/Navbar/Navbar"
import Hero from "../components/home/Hero/Hero"
import About from "../components/home/About/About"
import Other from "../components/home/Other/Other"
import Upcoming from "../components/home/Upcoming/Upcoming"
import CForm from "../components/home/CForm/CForm"
import Footer from "../components/Footer/Footer"

// markup
const IndexPage = () => {

  useEffect(()=>{
    const animOne = document.querySelectorAll('.anim-one');
    const animTwo = document.querySelectorAll('.anim-two');
  
    let options = {
        threshold: 0.25
      }
  
    const observer = new IntersectionObserver((entries)=>{
      entries.forEach((entry)=>{
        if(entry.intersectionRatio > 0){
          if(entry.target.classList.contains('anim-one')){
            entry.target.style.animation = `animUp 0.5s ${entry.target.dataset.delay} forwards linear`;
          }else if(entry.target.classList.contains('anim-two')){
            entry.target.style.animation = `animDown 0.5s ${entry.target.dataset.delay} forwards linear`;
          }
        }
      })
    }, options)
  
    animOne.forEach(anim => {
      observer.observe(anim);
    })
    animTwo.forEach(anim => {
      observer.observe(anim);
    })
  },[]);


  return (
    <>
      <Navbar/>
      <Hero/>
      <About/> 
      <Other/>
      {/* <Upcoming/> */}
      <CForm/>
      <Footer/>
    </>
  )
}

export default IndexPage
